export default __webpack_public_path__ + "static/media/bonus-3.19ae87ad.png";